import React from 'react'

import spinnerSvg from '~/shared/assets/images/sprite/spinner.svg'

import { StyledSpinner as S } from './Spinner.styles'

type TProps = {
  isFullScreen?: boolean
  height?: number
  svgSrc?: string
  className?: string
}

export const Spinner: React.FC<TProps> = ({
  isFullScreen = true,
  height = 76,
  svgSrc = spinnerSvg,
  className,
}) =>
  isFullScreen ? (
    <S.Wrapper className={className}>
      <S.Circle svg={svgSrc} height={height} />
    </S.Wrapper>
  ) : (
    <S.Circle svg={svgSrc} height={height} />
  )
